<template>
  <div class="premier12-wrap">
    <h1 class="premier12-hd">
      <span class="a11y-hidden">WBSC 프리미어 12 X wavve</span>
      <img src="../../assets/images/premier/logo.png" class="premier12-logo" alt="logo">
    </h1>
    <div class="tournament-info">
      <span class="date">11.17(일)</span>
      <span class="place">결승전</span>
      <span class="time">오후 7:00 &middot; 도쿄돔</span>
      <div class="country-info">
        <div class="country-box">
          <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="country-img">
          <span class="country-name">대한민국</span>
        </div>
        <span class="versus">vs</span>
        <div class="country-box">
          <img src="../../assets/images/premier/JP.png" alt="일본 국기" class="country-img">
          <span class="country-name">일본</span>
        </div>
      </div>
    </div>
    <div class="link-box">
      <a href="#" class="link-common link-onair" @click.prevent="goToLive()">
        <img src="../../assets/images/premier/img-badge.png" alt="독점" class="badge-only">
        무료 중계 보기
      </a>
      <a href="#" class="link-common link-wavve" @click.prevent="moveHome()">
        wavve 홈으로 가기
      </a>
    </div>
    <div class="ranking-now">
      <p class="ranking-now-txt">현재 대한민국 순위가 궁금하다면?</p>
      <a @click.prevent="rankingUrl()" class="link-direct">바로가기</a>
    </div>
    <p class="premier12-exclamation">
      <span class="premier12-exclamation-dot">
        <span class="premier12-exclamation-txt">WBSC 프리미어12 온라인 중계는 오직 wavve에서만 독점 생중계 됩니다.</span>
      </span>
      <span class="premier12-exclamation-dot">
        <span class="premier12-exclamation-txt">대한민국 출전 경기는 wavve에서 모두 무료로 시청 가능합니다.</span>
      </span>
    </p>
  </div>
</template>

<script>
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { enableBodyScroll } from '@/common/util/ui.utils'
export default {
  data () {
    return {
      device: '',
      title: '',
      channelId: '',
      startTime: ''
    }
  },
  methods: {
    moveHome () {
      sessionStorage.setItem('CONFIRM_PREMIER12', 'y')
      if (this.device === 'ios' && get(window, ['webkit', 'messageHandlers'], '') !== '') {
        window.webkit.messageHandlers.WebClose.postMessage('WebClose')
      } else if (this.device === 'android' && get(window, 'Android', '') !== '') {
        location.href = 'captvpooq://webclose'
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    goToLive () {
      if (this.device === 'ios') {
        utils.common.checkInstallApps(`player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`)
      } else if (this.device === 'android') {
        location.href = `captvpooq://player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`
      } else {
        utils.common.checkInstallApps('player')
      }
    },
    rankingUrl () {
      const url = 'https://premier12.wbsc.org/ko/2019/standings'
      if ((this.device === 'ios' && get(window, ['webkit', 'messageHandlers'], '') !== '') ||
        (this.device === 'android' && get(window, 'Android', '') !== '')) {
        location.href = `captvpooq://webview?url=${encodeURIComponent(url)}&external=y`
      } else {
        window.open(url, '_blank')
      }
    }
  },
  created () {
    enableBodyScroll()
    this.device = get(this.$route, ['query', 'device'], '')
    this.title = get(this.$route, ['query', 'title'], 'Premier12')
    this.channelId = get(this.$route, ['query', 'channelid'], 'S01')
    this.startTime = get(this.$route, ['query', 'starttime'], '19:00')
  }
}
</script>
<style lang="css" src="@/assets/new-css/premier12.css"></style>
